import Vue from "vue"
import Vuex from "vuex"

Vue.use(Vuex);  // Vue.use引用

// 放置公用数据
const state = {
  // 主侧边栏
  mainMenu: {
    // 菜单列表
    menuList: [
      {
        name: "首页",
        activeType: "01",
        icon: "",
        url: "/Home"
      },
      {
        name: "资讯中心",
        activeType: "02",
        icon: "",
        url: "/Information"
      },
      {
        name: "电子保险保函",
        activeType: "03",
        icon: "",
        url: "/InsuranceGuarantee"
      },
      {
        name: "电子银行保函",
        activeType: "04",
        icon: "",
        url: "/BankGuarantee"
      },
      {
        name: "关于我们",
        activeType: "05",
        icon: "",
        url: "/AboutUs"
      }
    ], // 菜单
    // 当前已经选择的菜单列表
    activeName: "01",
  },

  mainMenu2: {
    // 菜单列表
    menuList: [
      /*{
        name: "类型",
        activeType: "01",
        icon: "",
        url: ""
      },*/
      {
        name: "全部",
        activeType: "02",
        icon: "",
        url: "" // /Information/AllInformation
      },
      {
        name: "政策观察",
        activeType: "03",
        icon: "",
        url: "" // /Information/Policy
      },
      // {
      //   name: "行业资讯",
      //   activeType: "04",
      //   icon: "",
      //   url: "" // /Information/Industry
      // },
      // {
      //   name: "公司动态",
      //   activeType: "05",
      //   icon: "",
      //   url: "" // /Information/Company
      // }
    ], // 菜单
    // 当前已经选择的菜单列表
    activeName: "02",
  },

  mainMenu3: {
    // 菜单列表
    menuList: [
      {
        name: "办理流程",
        activeType: "01",
        icon: "",
        url: "/InsuranceGuarantee/Flow"
      },
      {
        name: "概念",
        activeType: "02",
        icon: "",
        url: "/InsuranceGuarantee/Concept"
      },
      {
        name: "优势",
        activeType: "03",
        icon: "",
        url: "/InsuranceGuarantee/Advantage",
      }
    ], // 菜单
    // 当前已经选择的菜单列表
    activeName: "03",
    list_class: '',
  },

  mainMenu4: {
    // 菜单列表
    menuList: [
      {
        name: "公司简介",
        activeType: "01",
        icon: "",
        url: "/AboutUs/Introduce"
      },
      /*{
        name: "发展历程",
        activeType: "02",
        icon: "",
        url: "/AboutUs/Development"
      },
      {
        name: "组织架构",
        activeType: "03",
        icon: "",
        url: "/AboutUs/Organization"
      }*/
    ], // 菜单
    // 当前已经选择的菜单列表
    activeName: "03",
    list_class: 'nav-list2',
  },

  // 当前选择侧边栏标题
  title: "资讯中心",
  path: "/", // 跳转链接

  /*// 当前选择侧边栏标题2
  title2: "资讯中心",
  path2: "", // 跳转链接*/

  // 资讯
  informationList: [
    {
      title: "住房和城乡建设部办公厅关于加强新冠肺炎疫情防控有序推动企业开复工工作的通知",
      type: "政策观察",
      date: "2020-02-26",
      con_title: "住房和城乡建设部办公厅关于加强新冠肺炎疫情防控有序推动企业开复工工作的通知",
      con_content: `<div class="l30">
                      <p>建办市〔2020〕5号</p>
                      <p>&emsp;</p>
                      <p>各省、自治区住房和城乡建设厅，直辖市住房和建设（管）委，新疆生产建设兵团住房和城乡建设局，有关行业协会，有关中央企业：</p>
                      <p class="ti25">为深入贯彻习近平总书记在统筹推进新冠肺炎疫情防控和经济社会发展工作部署会议上的重要讲话精神，认真落实党中央、国务院有关决策部署，加强房屋建筑和市政基础设施工程领域疫情防控，有序推动企业开复工，现就有关事项通知如下：</p>
                      <p>&emsp;</p>
                      <p class="fb">一、牢固树立大局意识，有序推动企业开复工</p>
                      <p><span class="fb">（一）分区分级推动企业和项目开复工。</span>地方各级住房和城乡建设主管部门要增强“四个意识”、坚定“四个自信”、做到“两个维护”，切实提高政治站位，在地方党委和政府统一领导下，根据本地疫情防控要求，开展企业经营和工程项目建设整体情况摸排，加强分类指导，以县（市、区、旗）为单位，有序推动企业和项目开复工。低风险地区要全面推动企业和工程项目开复工，中风险地区要有序推动企业和工程项目分阶段、错时开复工，高风险地区要确保在疫情得到有效防控后再逐步有序扩大企业开复工范围。涉及疫情防控、民生保障及其他重要国计民生的工程项目应优先开复工，加快推动重大工程项目开工和建设，禁止搞“一刀切”。</p>
                      <p>&emsp;</p>
                      <p><span class="fb">（二）切实落实防疫管控要求。</span>地方各级住房和城乡建设主管部门要积极与地方卫生健康主管部门、疾控部门加强统筹协调，根据实际情况制定出台建设工程项目疫情防控和开复工指南，重点对企业组织管理、人员集聚管理、人员排查、封闭管理、现场防疫物资储备、卫生安全管理、应急措施等方面提出明确要求，细化疫情防控措施，协助企业解决防控物资短缺等问题。强化企业主体责任，明确已开复工项目施工现场各方主体职责，严格落实各项防疫措施，切实保障企业开复工后不发生重大疫情事项，全力服务国家疫情防控大局。</p>
                      <p>&emsp;</p>
                      <p><span class="fb">（三）加强施工现场质量安全管理。</span>地方各级住房和城乡建设主管部门要加强开复工期间工程质量安全监管工作，加强风险研判，制定应对措施，创新监管模式，严防发生质量安全事故。对近期拟开复工项目，简化工程质量安全相关程序要求，优化工程质量安全相关手续办理流程，鼓励实行告知承诺制，加强事后监管，可以允许疫情解除后再补办有关手续。对工程项目因疫情不能返岗的管理人员，允许企业安排执有相应资格证书的其他人员暂时顶岗，加快工程项目开复工。督促企业落实安全生产主体责任，加强工程项目开复工前安全生产条件检查，重点排查深基坑、起重机械、高支模以及城市轨道交通工程等危险性较大的分部分项工程安全隐患，强化进场人员开复工前质量安全、卫生防疫等交底，对准备工作不充分、防范措施不落实、隐患治理不到位的工程项目，严禁擅自开复工。督促工程建设单位切实保障工程项目合理工期，严禁盲目抢工期、赶进度等行为。</p>
                      <p>&emsp;</p>
                      <p>二、加大扶持力度，解决企业实际困难</p>
                      <p><span class="fb">（四）严格落实稳增长政策。</span>地方各级住房和城乡建设主管部门要会同有关部门建立企业应对疫情专项帮扶机制，认真贯彻落实国家有关财税、金融、社保等支持政策，指导企业用足用好延期缴纳或减免税款、阶段性缓缴或适当返还社会保险费、减免房屋租金、加大职工技能培训补贴等优惠政策。加快推动银企合作，鼓励商业银行对信用评定优良的企业，在授信额度、质押融资、贷款利率等方面给予支持，有效降低企业融资成本。大力推行工程担保，以银行保函、工程担保公司保函或工程保证保险替代保证金，减少企业资金占用。严格落实涉企收费清单制度，坚决制止各类乱收费、乱罚款和乱摊派等行为，切实降低企业成本费用。</p>
                      <p>&emsp;</p>
                      <p><span class="fb">（五）加强合同履约变更管理。</span>疫情防控导致工期延误，属于合同约定的不可抗力情形。地方各级住房和城乡建设主管部门要引导企业加强合同工期管理，根据实际情况依法与建设单位协商合理顺延合同工期。停工期间增加的费用，由发承包双方按照有关规定协商分担。因疫情防控增加的防疫费用，可计入工程造价；因疫情造成的人工、建材价格上涨等成本，发承包双方要加强协商沟通，按照合同约定的调价方法调整合同价款。地方各级住房和城乡建设主管部门要及时做好跟踪测算和指导工作。</p>
                      <p>&emsp;</p>
                      <p><span class="fb">（六）加大用工用料保障力度。</span>加强部门协调联动，积极帮助企业做好工人返岗、建筑材料及设备运输、防疫物资保障等工作。统筹推进建筑业产业链上下游协同复工，加强上下游配套企业沟通，协助企业解决集中复工可能带来的短期内原材料短缺或价格大幅上涨等问题。强化企业用工保障，做好农民工返岗复工点对点服务保障工作，指导农民工主要输出地和输入地做好人员返岗的对接和服务，鼓励采用点对点包车等直达运输方式，减少分散出行风险。开展建筑工地用工需求摸查，及时发布用工需求信息，鼓励企业优先招用本地农民工，引导企业采取短期有偿借工等方式，相互调剂用工余缺。支持企业开展农民工在岗培训，鼓励有条件的地区设立复工补助资金，对农民工包车、生活、培训等提供补贴，解决农民工返岗的后顾之忧。</p>
                      <p>&emsp;</p>
                      <p><span class="fb">（七）切实减轻企业资金负担。</span>加快清理政府部门和国有企业拖欠民营企业账款，建立和完善防范拖欠长效机制，严禁政府和国有投资工程以各种方式要求企业带资承包，建设单位要按照合同约定按时足额支付工程款，避免形成新的拖欠。规范工程价款结算，政府和国有投资工程不得以审计机关的审计结论作为工程结算依据，建设单位不得以未完成决算审计为由，拒绝或拖延办理工程结算和工程款支付。严格执行工程建设领域保证金相关规定，保证金到期应当及时予以返还，未按规定或合同约定返还保证金的，保证金收取方应向企业支付逾期返还违约金。优化农民工工资保证金管理，疫情防控期间新开工的工程项目，可暂不收取农民工工资保证金。</p>
                      <p>&emsp;</p>
                      <p>三、加快推进产业转型，提升行业治理能力</p>
                      <p><span class="fb">（八）全面落实建筑工人实名制管理。</span>所有开复工项目原则上实行封闭管理，严格按照有关规定落实建筑工人实名制，实时记录施工现场所有人员进出场信息，实行体温检测制度，严禁无关人员进入施工现场，最大限度减少施工现场人员流动。对不能实行封闭管理的工程项目，要明确施工区域，做好建筑工人实名制管理，管控人员流动。有条件的工程项目要做到作业区、办公区和生活区的相对隔离，并对施工现场划分作业区域，根据作业特点定时记录区域内人员信息。</p>
                      <p>&emsp;</p>
                      <p><span class="fb">（九）大力推进企业数字化转型。</span>企业要加强信息化建设，更多通过线上方式布置工作、实施质量安全管理、召开会议、汇报情况、招聘队伍、采购建材和机械物资等，推进大数据、物联网、建筑信息模型（BIM）、无人机等技术应用，提高工作效率，减少人员聚集和无序流动。</p>
                      <p>&emsp;</p>
                      <p><span class="fb">（十）积极推动电子政务建设。</span>全面推行电子招投标和异地远程评标，对非必须到现场办理的业务，一律采用线上办理。对涉及防疫防控或保障城市运行必需等特殊情况的应急工程项目，经有关部门同意可以不进行招标。大力推行施工许可线上全流程办理和电子证照，进一步简化审批流程。有条件的地区可采用“在线申报、在线审批、自行打证”模式，不再经政府办事窗口现场办理。</p>
                      <p>&emsp;</p>
                      <p><span class="fb">（十一）推动资质审批告知承诺制改革。</span>实行资质申报、审批、公示、公告等业务的“一网通办”，鼓励采用邮寄等方式领取证书。各地可进一步扩大审批告知承诺制适用范围，减少资质申报材料，提高审批效率。</p>
                      <p>&emsp;</p>
                      <p>四、加强组织领导，落实监管责任</p>
                      <p><span class="fb">（十二）建立完善工作机制。</span>地方各级住房和城乡建设主管部门要认真履职尽责，在做好各项疫情防控工作的同时，统筹开展房屋建筑和市政基础设施工程领域企业和工程项目开复工工作。结合地方实际，进行专题研究部署，加强与相关部门协作联动，切实采取有效措施，协调解决企业开复工遇到的实际困难和问题，最大程度减少企业负担和损失，帮助企业尽快恢复正常生产经营。</p>
                      <p>&emsp;</p>
                      <p><span class="fb">（十三）加大指导监督力度。</span>地方各级住房和城乡建设主管部门要加强对疫情防控期间企业经营的监测分析和指导监督，落实监管职责，明确责任分工，加强对新建、改建、扩建项目开复工的监管，强化疫情防控措施落实，及时上报实施过程中存在的问题及相关建议。充分发挥行业协会作用，及时了解市场运行情况和企业诉求。加强舆论宣传引导，打造各方协力、众志成城的良好氛围，坚决打赢疫情防控的人民战争、总体战、阻击战。</p>
                      <p>&emsp;</p>
                      <p>中华人民共和国住房和城乡建设部办公厅</p>
                      <p>2020年2月26日</p>
                    </div>`
    },
    {
      title: "《关于积极应对疫情创新做好招投标工作保障经济平稳运行的通知》",
      type: "政策观察",
      date: "2020-02-08",
      con_title: "国家发展改革委办公厅关于积极应对疫情<br>创新做好招投标工作保障经济平稳运行的通知",
      con_content: `<div class="l30">
                      <p>&emsp;</p>
                      <p class="tc">发改电〔2020〕170号</p>
                      <p>&emsp;</p>
                      <p>各省、自治区、直辖市、新疆生产建设兵团发展改革委、招投标指导协调工作牵头部门、公共资源交易平台整合牵头部门，中国招标投标协会、全国公共资源交易平台、中国招标投标公共服务平台：</p>
                      <p class="ti25">新型冠状病毒感染肺炎疫情爆发以来，在党中央领导下，各地区、各有关部门和单位按照疫情防控工作部署要求，及时采取暂停招标项目现场交易活动、推行网上办理、减少到场要求等措施，有效减少人员聚集，阻断疫情传播，保障人民群众生命安全和身体健康。为在做好疫情防控工作的同时，做好“六稳”工作，有序开展招投标等公共资源交易活动，保障经济平稳运行，现就有关事项通知如下：</p>
                      <p class="ti25">一、坚决服从疫情防控和经济社会发展大局。各地招投标和公共资源交易平台工作要认真落实本地区关于疫情防控工作的统一部署要求，切实把人民群众生命安全和身体健康放在第一位。要切实保障疫情防控相关采购项目顺利进行，对于疫情防控急需的应急医疗设施、隔离设施等建设项目，符合《招标投标法》第六十六条规定的，可以不进行招标，由业主采用非招标方式采购，或者在招标时酌情缩短有关时限要求。要根据疫情防控形势变化、项目紧急程度和市场主体需求，及时动态调整工作安排，在确保安全的同时最大程度减轻对招投标等公共资源交易活动的影响。</p>
                      <p class="ti25">二、切实避免对招投标等交易活动“一刀切”。疫情防控期间，各级各类公共资源交易平台要立足公共服务职能定位，充分发挥软硬件优势，积极与当地疾控部门建立联动机制，在做好防控工作的前提下，全力支持和保障招投标等各类公共资源交易活动。特别对于涉及保障城市运行必需、疫情防控必需、涉及重要国计民生以及企业生产经营急需的项目，要建立“绿色通道”服务机制，创新方式方法，确保依法规范、及时有序进行。</p>
                      <p class="ti25">三、保证招标项目竞争度和投标质量。针对节后复工企业可能出现在岗人员不足、工作协同不便、人员流动受限的实际，引导招标人依法、合理设定招标文件发售、投标文件提交等时限，以便投标人做好投标准备；需购买纸质招标文件的，提供邮寄方式，不要求投标人到指定地点购买；需提交纸质投标文件的，允许邮寄提交。</p>
                      <p class="ti25">四、加快推进招投标全流程电子化。《国务院办公厅转发国家发展改革委关于深化公共资源交易平台整合共享指导意见的通知》（国办函〔2019〕41号）对2020年公共资源电子化交易全面实施提出了明确目标。各地要狠抓目标落实，加强部门协调，着力消除全流程电子化的盲点、断点、堵点，尽快在各行业领域全面推广电子招投标，实现发布招标公告公示、下载招标文件、提交投标文件、开标、评标、异议澄清补正、合同签订、文件归档等全流程电子化，扭转电子和纸质招投标双轨并行的局面。</p>
                      <p class="ti25">五、全面推行在线投标、开标。为有效降低现场投标、开标带来的人员聚集风险，同时降低企业交易成本，各地要依托电子招投标交易平台，加快部署在线投标、开标系统，制定明确时间表，年内实现所有依法必须进行招标的项目在线投标、开标。</p>
                      <p class="ti25">六、积极推广电子评标和远程异地评标。各地要加快建设完善电子评标系统，应用信息化工具辅助评标，提高评标效率；完善远程异地评标系统及技术规范，尽早实现省内常态化运行，并为跨省运行创造条件，有效减少评标人员聚集，实现有限专家资源充分共享；积极应对远程异地评标等对传统属地监管模式带来的挑战，建立跨区域协同监管机制。疫情防控期间，采取随机抽取方式难以组建评标委员会的，可依法由招标人自行确定专家；确有需求的地方，可以在监管到位的前提下选择适当的招标项目探索开展基于网络协同的专家分散评标。</p>
                      <p class="ti25">七、改进投标担保方式。在全面推行投标保证金线上缴退的同时，大力推广使用保函特别是<span class="fb cFF0000">电子保函</span>替代现金保证金，实现在线提交、在线查核。鼓励调整纸质保函提交方式，建议招标人在开标前不强制要求提交纸质原件，由中标候选人在中标候选人公示前提交并在网上公示。鼓励招标人对简单小额项目不要求提供投标担保，对中小企业投标人免除投标担保，减轻企业负担。</p>
                      <p class="ti25">八、支持社会力量参与提升招投标服务供给。为保障在线开标、远程异地评标，以及满足避免人员过分集中对开标评标场所的需求，各地要注重发挥社会力量积极性，增加电子招投标交易平台和开标评标场所的服务供给，允许招标人选择依法规范并符合行政监督要求的市场主体建设运营的电子招投标交易平台开展招标，在监管到位前提下探索允许在社会化交易场所开标评标。</p>
                      <p class="ti25">九、大力推进招投标行政监督电子化。各地要积极适应招投标全流程电子化的新形势，加快行政监督方式手段的电子化、智慧化。按照政务信息化要求，依托电子招投标交易平台，加快部署行政监督窗口和监督工具，实现对电子招投标交易全程事中事后监管。</p>
                      <p class="ti25">十、保障投标人和潜在投标人合法权益。对于疫情防控期间暂停开标评标活动的招标项目，有关部门、单位和公共资源交易中心要指导招标人通过发布招标文件澄清或修改公告等适当方式另行通知招投标活动时间。对招投标活动实行减少人员聚集等相关措施时，确保对所有投标人公平公正。要保证异议、投诉渠道畅通，不得借疫情防控之名实施排斥限制投标人等违法违规行为。</p>
                      <p class="ti25">十一、切实尽责履行政府职能。各级发展改革委或者本级政府确定的其他牵头部门应当加强工作统筹，敢于担当负责，会同有关招投标行政监督部门，按照本地区疫情防控统一部署要求，认真做好招投标指导协调工作。要加强政策宣传解读，畅通电话、网络等咨询渠道，及时为市场主体释疑解惑，保障招投标活动积极稳妥有序开展。要按照国家发展改革委《关于加强投资项目远程审批服务保障新型冠状病毒感染肺炎疫情防控期间项目办理工作的通知》（发改电〔2020〕66号）要求，实行招标方案审批核准的电子化、便利化。各地公共资源交易平台整合牵头部门要切实加强对本地区公共资源交易工作的指导协调，确保在疫情防控期间公共资源交易市场不乱、监管不断。</p>
                      <p class="ti25">十二、加强招投标活动服务保障。各地公共资源交易中心在暂停提供现场交易服务期间，要通过电话、网络等方式进行业务咨询及办理，保障项目办理不断档；在提供现场交易服务时，要严格按要求落实人员登记、健康监测、环境消毒等防控措施；要优化和简并办事流程，推行见证证明、场所预约等服务事项网上办理，利用在线核验、邮寄、告知承诺等方式取消或者减少人员到场要求；确需现场递交文件资料的，要做到即交即走，减少人员聚集程度及滞留时间。中国招标投标公共服务平台和各省级招标公告公示发布媒介要充分利用电子招投标交易平台及移动互联网技术，为市场主体提供稳定、便捷的在线发布服务；对疫情防控相关招标项目的业务办理予以专门优先保障。全国公共资源交易平台要加强动态监测，密切跟踪各地公共资源交易平台运行情况。电子招投标交易平台开发运营单位要加强值守，快速响应，做好技术服务保障；便利CA数字证书办理程序，尽可能通过网络或邮寄开展原件审核、介质发放等工作。相关单位要加快推进CA数字证书网络共享，运用手机扫码等技术实现免插介质完成身份验证、签名盖章、加密解密等交易流程。</p>
                      <p class="ti25">十三、充分发挥行业协会作用。中国招标投标协会等行业组织要充分发挥政府与市场的桥梁纽带作用，面向市场主体加强疫情防控相关招投标政策的宣传解读，引导行业自律，及时了解和反映行业运行状况、市场主体诉求，并积极建言献策。</p>
                      <p class="ti25">各地区、各有关部门和单位要从贯彻党中央、国务院决策部署，努力实现今年经济社会发展目标的高度，充分认识当前形势下创新开展招投标工作的紧迫性和重要性，立足当前、着眼长远，积极探索、精准施策，既要解决当前突出问题，更要注重建立长效机制，加快提升招投标工作服务经济社会发展大局的质量和水平。各地创新做好招投标工作的典型经验做法、遇到的困难问题、意见建议，请及时报送国家发展改革委（法规司）。</p>
                      <p class="ti25">特此通知。</p>
                      <p>&emsp;</p>
                      <p class="tc">国家发展改革委办公厅</p>
                      <p class="tc">2020年2月8日</p>
                    </div>`
    },
    {
      title: "住房和城乡建设部等部门关于加快推进房屋建筑和市政基础设施工程实行工程担保制度的指导意见",
      type: "政策观察",
      date: "2019-06-20",
      con_title: "住房和城乡建设部等部门关于加快推进房屋建筑和市政基础设施工程实行工程担保制度的指导意见",
      con_content: `<div class="l30">
                      <p class="tc">建市〔2019〕68号</p>
                      <p>各省、自治区住房和城乡建设厅、发展改革委、财政厅、人力资源社会保障厅，直辖市住房和城乡建设（管）委、发展改革委、财政局、人力资源社会保障局，计划单列市发展改革委，新疆生产建设兵团住房和城乡建设局、发展改革委、财政局、人力资源社会保障局，中国人民银行上海总部，各分行、营业管理部，省会（首府）城市中心支行，副省级城市中心支行，各银保监局：</p>
                      <p class="ti25">工程担保是转移、分担、防范和化解工程风险的重要措施，是市场信用体系的主要支撑，是保障工程质量安全的有效手段。当前建筑市场存在着工程防风险能力不强，履约纠纷频发，工程欠款、欠薪屡禁不止等问题，亟需通过完善工程担保应用机制加以解决。为贯彻落实《国务院办公厅关于清理规范工程建设领域保证金的通知》（国办发〔2016〕49号）、《国务院办公厅关于促进建筑业持续健康发展的意见》（国办发〔2017〕19号）、《国务院办公厅关于全面开展工程建设项目审批制度改革的实施意见》（国办发〔2019〕11号），进一步优化营商环境，强化事中事后监管，保障工程建设各方主体合法权益，现就加快推进房屋建筑和市政基础设施工程实行工程担保制度提出如下意见。</p>
                      <p class="ti25">一、总体要求</p>
                      <p class="ti25">以习近平新时代中国特色社会主义思想为指导，深入贯彻党的十九大和十九届二中、三中全会精神，落实党中央、国务院关于防范应对各类风险、优化营商环境、减轻企业负担的工作部署，通过加快推进实施工程担保制度，推进建筑业供给侧结构性改革，激发市场主体活力，创新建筑市场监管方式，适应建筑业“走出去”发展需求。</p>
                      <p class="ti25">二、工作目标</p>
                      <p class="ti25">加快推行投标担保、履约担保、工程质量保证担保和农民工工资支付担保。支持银行业金融机构、工程担保公司、保险机构作为工程担保保证人开展工程担保业务。到2020年，各类保证金的保函替代率明显提升；工程担保保证人的风险识别、风险控制能力显著增强；银行信用额度约束力、建设单位及建筑业企业履约能力全面提升。</p>
                      <p class="ti25">三、分类实施工程担保制度</p>
                      <p class="ti25">（一）推行工程保函替代保证金。加快推行银行保函制度，在有条件的地区推行工程担保公司保函和工程保证保险。严格落实国务院清理规范工程建设领域保证金的工作要求，对于投标保证金、履约保证金、工程质量保证金、农民工工资保证金，建筑业企业可以保函的方式缴纳。严禁任何单位和部门将现金保证金挪作他用，保证金到期应当及时予以退还。</p>
                      <p class="ti25">（二）大力推行投标担保。对于投标人在投标有效期内撤销投标文件、中标后在规定期限内不签订合同或未在规定的期限内提交履约担保等行为，鼓励将其纳入投标保函的保证范围进行索赔。招标人到期不按规定退还投标保证金及银行同期存款利息或投标保函的，应作为不良行为记入信用记录。</p>
                      <p class="ti25">（三）着力推行履约担保。招标文件要求中标人提交履约担保的，中标人应当按照招标文件的要求提交。招标人要求中标人提供履约担保的，应当同时向中标人提供工程款支付担保。建设单位和建筑业企业应当加强工程风险防控能力建设。工程担保保证人应当不断提高专业化承保能力，增强风险识别能力，认真开展保中、保后管理，及时做好预警预案，并在违约发生后按保函约定及时代为履行或承担损失赔付责任。</p>
                      <p class="ti25">（四）强化工程质量保证银行保函应用。以银行保函替代工程质量保证金的，银行保函金额不得超过工程价款结算总额的3%。在工程项目竣工前，已经缴纳履约保证金的，建设单位不得同时预留工程质量保证金。建设单位到期未退还保证金的，应作为不良行为记入信用记录。</p>
                      <p class="ti25">（五）推进农民工工资支付担保应用。农民工工资支付保函全部采用具有见索即付性质的独立保函，并实行差别化管理。对被纳入拖欠农民工工资“黑名单”的施工企业，实施失信联合惩戒。工程担保保证人应不断提升专业能力，提前预控农民工工资支付风险。各地住房和城乡建设主管部门要会同人力资源社会保障部门加快应用建筑工人实名制平台，加强对农民工合法权益保障力度，推进建筑工人产业化进程。</p>
                      <p class="ti25">四、促进工程担保市场健康发展</p>
                      <p class="ti25">（六）加强风险控制能力建设。支持工程担保保证人与全过程工程咨询、工程监理单位开展深度合作，创新工程监管和化解工程风险模式。工程担保保证人的工作人员应当具有第三方风险控制能力和工程领域的专业技术能力。</p>
                      <p class="ti25">（七）创新监督管理方式。修订保函示范文本，修改完善工程招标文件和合同示范文本，推进工程担保应用；积极发展电子保函，鼓励以工程再担保体系增强对担保机构的信用管理，推进“互联网+”工程担保市场监管。</p>
                      <p class="ti25">（八）完善风险防控机制。推进工程担保保证人不断完善内控管理制度，积极开展风险管理服务，有效防范和控制风险。保证人应不断规范工程担保行为，加强风险防控机制建设，发展保后风险跟踪和风险预警服务能力，增强处理合同纠纷、认定赔付责任等能力。全面提升工程担保保证人风险评估、风险防控能力，切实发挥工程担保作用。鼓励工程担保保证人遵守相关监管要求，积极为民营、中小建筑业企业开展保函业务。</p>
                      <p class="ti25">（九）加强建筑市场监管。建设单位在办理施工许可时，应当有满足施工需要的资金安排。政府投资项目所需资金应当按照国家有关规定确保落实到位，不得由施工单位垫资建设。对于未履行工程款支付责任的建设单位，将其不良行为记入信用记录。</p>
                      <p class="ti25">（十）加大信息公开力度。加大建筑市场信息公开力度，全面公开企业资质、人员资格、工程业绩、信用信息以及工程担保相关信息，方便与保函相关的人员及机构查询。</p>
                      <p class="ti25">（十一）推进信用体系建设。引导各方市场主体树立信用意识，加强内部信用管理，不断提高履约能力，积累企业信用。积极探索建筑市场信用评价结果直接应用于工程担保的办法，为信用状况良好的企业提供便利，降低担保费用、简化担保程序；对恶意索赔等严重失信企业纳入建筑市场主体“黑名单”管理，实施联合惩戒，构建“一处失信、处处受制”的市场环境。</p>
                      <p class="ti25">五、加强统筹推进</p>
                      <p class="ti25">（十二）加强组织领导。各地有关部门要高度重视工程担保工作，依据职责明确分工，明晰工作目标，健全工作机制，完善配套政策，落实工作责任。加大对工程担保保证人的动态监管，不断提升保证人专业能力，防范化解工程风险。</p>
                      <p class="ti25">（十三）做好宣传引导。各地有关部门要通过多种形式积极做好工程担保的宣传工作，加强舆论引导，促进建筑市场主体对工程担保的了解和应用，切实发挥工程担保防范和化解工程风险的作用。</p>
                      <p>&emsp;</p>
                      <p class="tc">中华人民共和国住房和城乡建设部</p>
                      <p class="tc">中华人民共和国国家发展和改革委员会</p>
                      <p class="tc">中华人民共和国财政部</p>
                      <p class="tc">中华人民共和国人力资源和社会保障部</p>
                      <p class="tc">中国人民银行</p>
                      <p class="tc">中国银行保险监督管理委员会</p>
                      <p class="tc">2019年6月20日</p>
                      <p class="ti25">（此件主动公开）</p>
                    </div>`
    },
  ],

  inforDetail: {}  // 资讯详情数据
}

// 暴露，让外部可以引用
export default new Vuex.Store({
  state,
})



// WEBPACK FOOTER //
// ./src/store/store.js